import React from "react";

import {OgImage} from "../../../opengraph/components/OgImage";
import {PropsValidator} from "../../../opengraph/utils/ogPathMap";
import {getCareDiscoveryColorScheme} from "../../constants/Reason/getCareDiscoveryColorScheme";

/**
 * @param root should be passed from `getHtml`
 */
type Props = {
  id: string;
  title: string;
  root?: string;
};

export const propsValidator: PropsValidator = (props: unknown): props is Props =>
  // @ts-expect-error TS2322: Type 'unknown' is not assignable to type 'boolean'.
  props &&
  typeof props === "object" &&
  typeof (props as Props).title === "string" &&
  typeof (props as Props).id === "string";

const GetCareSlugOg = ({id, title, root = "https://carbonhealth.com"}: Props): JSX.Element => {
  const colorScheme = getCareDiscoveryColorScheme(id, title);

  return (
    <OgImage root={root}>
      <div className="df h100p w100p" style={{backgroundColor: colorScheme.backgroundColor}}>
        <div className="fx4 df fdc jcsb pb24 pt18 ph18">
          <img src={`${root}/static/img/v5/logo-black.svg`} alt="" width={300} />
          <div className="dg gafr gg6">
            <strong className="fs26 font-mb ttu" style={{color: colorScheme.color}}>
              Book an Appointment
            </strong>
            <h1 className="font-csb fs60">{title}</h1>
          </div>
        </div>
        <div className="fx3">
          <img
            height="100%"
            src={`${root}/static/img/v5/patterns/full/${colorScheme.patternSrc}.png`}
            alt=""
          />
        </div>
      </div>
    </OgImage>
  );
};

export default GetCareSlugOg;
